"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomAiRemoveMessage = void 0;
var common_1 = require("@timeflies/common");
var joi_1 = __importDefault(require("joi"));
var message_1 = require("../../message");
exports.RoomAiRemoveMessage = message_1.createMessage('room/ai/remove', joi_1.default.object({
    playerId: common_1.playerIdSchema
}))
    .withResponse();
